import { render, staticRenderFns } from "./CarruselDigital.vue?vue&type=template&id=d6944ebe&scoped=true&"
import script from "./CarruselDigital.vue?vue&type=script&lang=js&"
export * from "./CarruselDigital.vue?vue&type=script&lang=js&"
import style0 from "./CarruselDigital.vue?vue&type=style&index=0&id=d6944ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6944ebe",
  null
  
)

export default component.exports